<template>
    <div>
        <el-dialog title="驾驶员信息" :visible.sync="dialogVisible" width="50%" :modal-append-to-body="false">
            <el-descriptions title="" :column="2">
                <el-descriptions-item label="机动车驾驶员姓名">{{ data.name }}</el-descriptions-item>
                <el-descriptions-item label="驾驶员婚姻状况">{{ data.maritalStatus }}</el-descriptions-item>
                <el-descriptions-item label="驾驶员性别">{{ data.gender }}</el-descriptions-item>
                <el-descriptions-item label="出生日期">{{ data.birthday }}</el-descriptions-item>
                <el-descriptions-item label="驾驶员手机号">{{ data.phone }}</el-descriptions-item>
                <el-descriptions-item label="驾驶员民族">{{ data.nationality }}</el-descriptions-item>
                <el-descriptions-item label="驾驶员通信地址">{{ data.mailingAddress }}</el-descriptions-item>
                <el-descriptions-item label="驾驶员外语能力">{{ data.foreignLanguages }}</el-descriptions-item>
                <el-descriptions-item label="驾驶员学历">{{ data.education	 }}</el-descriptions-item>
                <el-descriptions-item label="户口登记机关名称">{{ data.householdRegistrationAuthority }}</el-descriptions-item>
                <el-descriptions-item label="户口地址或长住地址">{{ data.domicile }}</el-descriptions-item>
                <el-descriptions-item label="驾驶员合同（或协议）签署公司">{{ data.contractingCompany }}</el-descriptions-item>
                <el-descriptions-item label="驾驶员照片文件编号">{{ data.claude }}</el-descriptions-item>
                <el-descriptions-item label="机动车驾驶证扫描文件编号">{{ data.drivingLicenceFile }}</el-descriptions-item>
                <el-descriptions-item label="准驾车型">{{ data.quasiDrivingType }}</el-descriptions-item>
                <el-descriptions-item label="初次领取驾驶证日期">{{ data.firstLicenseDate }}</el-descriptions-item>
                <el-descriptions-item label="驾驶证有效期限起">{{ data.drivingLicenceStart }}</el-descriptions-item>
                <el-descriptions-item label="驾驶证有效期限止">{{ data.drivingLicenceEnd }}</el-descriptions-item>
                <el-descriptions-item label="是否巡游出租汽车驾驶员">{{ data.cruiseTaxi }}</el-descriptions-item>
                <el-descriptions-item label="资格证发证日期">{{ data.certificationIssueDate	 }}</el-descriptions-item>
                <el-descriptions-item label="初次领取资格证日期">{{ data.firstLicenseCertification }}</el-descriptions-item>
                <el-descriptions-item label="资格证有效起始日期">{{ data.certificationStart	 }}</el-descriptions-item>
                <el-descriptions-item label="资格证有效截止日期">{{ data.certificationEnd }}</el-descriptions-item>
                <el-descriptions-item label="驾驶员在平台的注册日期">{{ data.registrationDate }}</el-descriptions-item>
                <el-descriptions-item label="是否在驾驶员黑名单中">{{ data.blacklist }}</el-descriptions-item>
                <el-descriptions-item label="是否专职驾驶员">{{ data.fullTimeDriver }}</el-descriptions-item>
                <el-descriptions-item label="公司名称">{{ data.contractingCompany }}</el-descriptions-item>
                <el-descriptions-item label="运营类型">{{ data.operationType }}</el-descriptions-item>
                <el-descriptions-item label="网约车驾驶员资格证号">{{ data.certification }}</el-descriptions-item>
                <el-descriptions-item label="网约车驾驶员证发证机构">{{ data.orgName }}</el-descriptions-item>
                <el-descriptions-item label="合同（或协议）有效期起">{{ data.contractLifeStart }}</el-descriptions-item>
                <el-descriptions-item label="合同（或协议）有效期止">{{ data.contractLifeEnd }}</el-descriptions-item>
                <el-descriptions-item label="国籍">{{ data.nation }}</el-descriptions-item>
                <el-descriptions-item label="紧急情况联系人">{{ data.emergencyContact }}</el-descriptions-item>
                <el-descriptions-item label="紧急情况联系人电话">{{ data.emergencyPhone }}</el-descriptions-item>
                <el-descriptions-item label="紧急情况联系人通讯地址">{{ data.emergencyMailingAddress }}</el-descriptions-item>
                <el-descriptions-item label="状态">{{ ['有效','无效'][data.status - 1] }}</el-descriptions-item>
                <el-descriptions-item label="操作标识">{{ ['新增','修改'][data.flag - 1] }}</el-descriptions-item>
                <el-descriptions-item label="更新时间">{{ data.updateTime }}</el-descriptions-item>
            </el-descriptions>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            dialogVisible: false,
            data: {}
        };
    },
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {
        initData(data) {
            this.data = data
            this.dialogVisible = true
        },
        closeClick() {
            this.dialogVisible = false
        }
    },
};
</script>
<style scoped lang="less">
::v-deep .el-descriptions .el-descriptions-item__cell {
    padding-bottom: 20px;
}
</style>